<div [class]="classes()">
  <div class="placeholder-state__container">
    @if (isFullPage() && illustration(); as illustration) {
      <ftr-illustration class="placeholder-state__illustration" [illustration]="illustration" />
    }
    <svg class="placeholder-state__icon" [ftrIcon]="icon()" [iconSize]="24" [iconColor]="iconColor() ?? 'Grey40'"></svg>
    <div class="placeholder-state__body">
      @if (title(); as title) {
        <header class="placeholder-state__title">{{ title }}</header>
      }
      <div class="placeholder-state__content">
        @if (message(); as message) {
          <p class="placeholder-state__message">{{ message }}</p>
        }
        <ng-content />
      </div>
    </div>
  </div>
</div>
